import type { JournalData } from "@qendo/profile/journal";
import { LegacyJournalId, type ScaleType, TrackableType } from "@qendo/trackables";
import { useGlobalSearchParams } from "expo-router";
import { useMemo } from "react";
import { PeriodForm } from "~/components/form/journal/PeriodForm";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useJournal } from "~/providers/JournalProvider";
import { useTrackable } from "~/providers/TrackableProvider";

export default function EditPeriod() {
    const { id }: { id: string } = useGlobalSearchParams();
    const { handleDismiss } = useDismiss();
    const { findJournal, canUpdateJournal } = useJournal();
    const { findTrackable } = useTrackable();

    const journal = useMemo(() => findJournal(id), [id, findJournal]) as JournalData<
        TrackableType.journal,
        ScaleType.cycle
    > | null;
    const trackable = findTrackable(LegacyJournalId.period);

    if (!journal || journal?.trackable_id !== trackable?.id || !canUpdateJournal(TrackableType.journal)) {
        return <Dismiss />;
    }

    return <PeriodForm onRequestClose={handleDismiss} journal={journal} asRoute />;
}
